// Dashboard click-through to the A/R page (David, 2026-10-21): an Accounts Receivable
// bar opens A/R on the tab it stands for — Insurer Owed on "By insurance", Patient Owed
// on "By patient" — with no date range, since the bar is an aging bucket, not a period.
//
// The same two-part hand-off as ledgerLink.js: the tab travels in one module-scoped
// variable, keyed by practice, that the A/R page reads once on mount; the navigation
// pushes `/p/<practice>/ar` and announces it with `popstate`, which App.js already
// honours. Back returns to the dashboard.

let pending = null; // { practiceId, tab }

export const AR_TABS = ['by_insurance', 'patients'];

export function openArTab(practiceId, tab) {
  if (!practiceId || !AR_TABS.includes(tab)) return;
  pending = { practiceId: Number(practiceId), tab };
  try {
    window.history.pushState({}, '', `/p/${practiceId}/ar`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch (_) {
    /* a browser without the History API: the tab waits for the next A/R visit */
  }
}

/** The tab handed to this practice's A/R page, or null. Read in the page's state
    initialiser; `clearArLink` runs from its mount effect (React may call an
    initialiser twice, and the second call must still see it). */
export function peekArTab(practiceId) {
  if (!pending || pending.practiceId !== Number(practiceId)) return null;
  return pending.tab;
}

export function clearArLink() {
  pending = null;
}
